import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import SearchIcon from "@atlaskit/icon/core/search";

import { wacToken } from "@/libraries/design/foundations";

const searchIconStyle = css({
    background: "transparent",
    border: 0,
    cursor: "pointer",
    padding: 0,
    display: "flex",
    alignItems: "center",
    color: wacToken("color.neutral.dark100")
});

const searchIconSvgStyle = css({
    "color": wacToken("color.primary.black"),
    "borderRadius": "50%",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    ":hover": {
        backgroundColor: wacToken("color.neutral.light100")
    }
});

export const UniformSearchButton = () => {
    let searchLabel = "Search";
    try {
        const intl = useIntl();
        searchLabel = intl.formatMessage({
            id: "SearchButton.label",
            defaultMessage: "Search"
        });
    } catch (e) {
        // IntlProvider not available, use default
    }
    return (
        <button
            type="submit"
            css={searchIconStyle}
            id="search-icon"
            aria-label={searchLabel}
            data-event="clicked"
            data-event-component="button"
            data-event-container="searchButton"
        >
            <span css={searchIconSvgStyle}>
                <SearchIcon label={searchLabel} size="medium" />
            </span>
        </button>
    );
};
